import { paymentTypesConstants } from '../_constants';

//-- get the list of terms
export function getPaymentTypesList(state = {}, action) {
  switch (action.type) {
    case paymentTypesConstants.PAYMENT_TYPES_LIST_REQUEST:
      return {
        getPaymentTypesList: false
      };

    case paymentTypesConstants.PAYMENT_TYPES_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { isGetAdvertismentList: true, getPaymentTypesList: action.successAction };

    case paymentTypesConstants.PAYMENT_TYPES_LIST_FAILURE:
      return {
        getPaymentTypesList: false,
      };

    case paymentTypesConstants.PAYMENT_TYPES_SEARCH_REQUEST:
      return { isGetAdvertismentList: true, getPaymentTypesList: action.successAction.data };

    default:
      return state
  }
}